// @flow

import './stimulus'

import qs from 'qs'
import * as apis from './services/apis'
import * as forms from './modules/forms'
import * as recaptcha from './modules/recaptcha'
import * as utils from './lib/utils'

// libdefs for flow on rollup replace values
declare var ENV: string
declare var VERSION: string
declare var API_URL: string

const ENVIRONMENT = {
  env: ENV,
  version: VERSION
}

const ENDPOINTS = {
  main: API_URL
}

interface InitParams {
  endpoints?: Object,
  recaptchaSiteKey?: string | void,
  appId?: string | void
}

interface ApiInterface {
  collect: apis.CollectAPI
}

interface FormsInterface {
  init (): void
}

interface Utils {
}

export default class Convrrt {
  config: InitParams
  apis: ApiInterface
  forms: FormsInterface
  utils: Utils

  constructor (opts: InitParams = {}) {
    this.config = {
      appId: opts.appId,

      endpoints: {
        ...ENDPOINTS,
        ...opts.endpoints
      },

      recaptchaSiteKey: opts.recaptchaSiteKey
    }

    this.apis = {
      collect: new apis.CollectAPI({
        baseURL: this.config.endpoints.main
      })
    }

    this.utils = utils
  }

  async initMerge () {
    let data = {}
    let urlParams = qs.parse(window.location.search.slice(1))
    let appId = this.config.appId || ''
    let xid = urlParams.inf_contact_key

    if (!appId || !xid) {
      console.debug(`skipping contact merge missing xid: ${xid} or appId: ${appId}`)
    }

    try {
      if (urlParams.inf_contact_key) {
        let result = await this.apis.collect.loadMerge({
          appId: this.config.appId,
          xid: urlParams.inf_contact_key
        })
        data = result.data
      }

      for (let key in data) {
        let elm = document.querySelector(`[name="fields[${key}]"]`)
        if (elm) {
          elm.value = data[key]
        }
      }
    } catch (e) {
      console.debug('could not load merge data from', {xid, appId})
    }

    delete urlParams.inf_contact_key

    for (let key in urlParams) {
      try {
        let elm = document.querySelector(`#${key},[data-url-key="${key}"]`)
        if (elm) {
          elm.value = urlParams[key]
        }
      } catch (e) {
        console.debug('failed to query element', e)
      }
    }
  }

  initForms ({ redirectUrl } = {}) {
    if (!this.config.recaptchaSiteKey) {
      throw new Error('missing recaptchaSiteKey')
    }

    return recaptcha.Init().then((grecaptcha) => {
      return forms.Init({
        lib: this,
        grecaptcha,
        redirectUrl,
        recaptchaSiteKey: this.config.recaptchaSiteKey
      })
    })
  }

  static version () {
    return ENVIRONMENT
  }
}
